import * as React from "react";
function SvgExit(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.586 13l-1.292 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L18.586 11H10v2h8.586zM3 5a2 2 0 012-2h10a2 2 0 012 2v3h-2V5H5v14h10v-3h2v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgExit);
export default ForwardRef;
